import { useMutation } from '@tanstack/react-query';

import { queryClient } from '../../queryClient';

import { preferencesApi } from './api';
import { preferencesQueryKey } from './preferencesQueryKey';
import { usePreferencesMutation } from './usePreferencesMutation';

const MUTATION_KEY = ['update-preferences-countries'];

const updateFunction = async (countries: number[]) => {
  await preferencesApi.setCountriesSettings(countries);
  queryClient.setQueryData<number[]>(preferencesQueryKey.countries(), () => countries);
};

export const useCountryPreferencesMutation = (onClose: () => void) => {
  return usePreferencesMutation({ mutationKey: MUTATION_KEY, updateFunction, onClose });
};

export const useUpdateCountriesMutation = () => {
  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn: updateFunction,
  });
};
